export const signUpStatus = {
  HMO: 'hmo_flow',
  TELEHEALTH: 'telehealth_flow',
  LOGIN: 'login_flow',
  SUPPORT: 'contact_support',
  TRY_AGAIN: 'try_again',
  APPROVED: 'approved',
  SSN_VALID: 'ssn_valid',
}

export const signUpFlowTypes = {
  HMO: 'hmo',
  TELEHEALTH: 'telehealth',
}
